import script from "./PublicationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationTable.vue?vue&type=script&setup=true&lang=js"

import "./PublicationTable.vue?vue&type=style&index=0&id=7fbad3ba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fbad3ba"]])

export default __exports__